import {
  CheckEligibilityRequest,
  CheckEligibilityFormFields,
  ScholarshipsSelectType,
} from './types';

/**
 * Maps data from UI format to server format
 * @param data User provided data
 * @returns result
 * */
export const mapFromUiToServer = (
  data: CheckEligibilityFormFields
): CheckEligibilityRequest => ({
  identity_number: data.identityNumber,
  phone: data.phone,
  password: data.password,
  residency_status: data.residencyStatus,
  academic_institution_id: Number(data.academicInstitution?.value),
  currently_studying: data.currentlyStudying,
  other_bachelor: data.otherBachelor,
  eligible_for_assistance: data.eligibleForAssistance || undefined,
  scholarships: [ScholarshipsSelectType.NONE],
  other_scholarship: false,
  other_scholarship_name: '',
  // Must be undefined, not '': backend validates it with @IsNumber() and
  // @IsOptional() only skips null/undefined, so '' fails eligibility check.
  other_scholarship_amount: undefined,
  terms: Number(data.termsConfirm),
  email: data.email,
  born_in_ethiopia: data.bornInEthiopia,
  parent_born_in_ethiopia:
    data.bornInEthiopia === false ? data.parentBornInEthiopia : undefined,
});
